import { Component, inject, model, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';

import { AuthService } from '@/app/auth/auth.service';
import { ApiErrorResponse, ApiResponse } from '@/types/api-response.model';
import { LoginData } from '@/types/user.interfaces';
import { NotificationService } from '@/app/services/common/notification.service';
import { TypographyComponent } from '@/app/components/ui/typography.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    PasswordModule,
    ToastModule,
    TypographyComponent

  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']

})
export class LoginComponent {
  private auth = inject(AuthService);
  private router = inject(Router);
  private notificationService = inject(NotificationService);

  email = model<string>('');
  password = model<string>('');

  loading = signal<boolean>(false);
  errorMessage = signal<string | null>(null);

  async onLogin(): Promise<void> {
    if (!this.email() || !this.password()) return;

    this.loading.set(true);
    this.errorMessage.set(null);

    try {
      const res: ApiResponse<LoginData> =
        await this.auth.login(this.email(), this.password());

      this.notificationService.showSuccess(
        'Login Successful',
        res.message || 'You have logged in successfully.'
      );

      setTimeout(() => {
        this.router.navigate(['/dashboard']);
      }, 500);

    } catch (err) {
      this.loading.set(false);

      if (err instanceof HttpErrorResponse) {
        const errorBody = err.error as ApiErrorResponse;
        const beMessage = errorBody?.message;

        const detail = Array.isArray(beMessage)
          ? beMessage.join(', ')
          : (beMessage || 'server internal error');

        this.errorMessage.set(detail);
        this.notificationService.handleHttpError(err);
      } else {
        const fallbackMsg = 'an unknown error occurred.';
        this.errorMessage.set(fallbackMsg);
        this.notificationService.showError('Error', fallbackMsg);
      }
    }
  }

}
